import gsap, { SplitText, ScrollTrigger } from '@lib/gsap'
import { onMount, onDestroy } from "./_";

export default function (element: HTMLElement, dataset: any) {
  let splitElement: SplitText | null = null;
  let scrollTriggerInstance: ScrollTrigger | null = null;

  onMount(() => {
    splitElement = new SplitText('.about_content', {
      type: 'lines, words, chars',
      linesClass: 'aboutLine',
      wordsClass: 'aboutWord',
      charsClass: 'aboutChar',
    })

    gsap.set('.aboutLine', {
      overflow: 'hidden'
    })

    gsap.set(splitElement.words, {
      yPercent: 100
    })

    // Create ScrollTrigger animation
    scrollTriggerInstance = ScrollTrigger.create({
      trigger: element,
      start: 'top 35%',
      once: true,
      onEnter: () => {
        document.querySelectorAll('.aboutLine').forEach((e, i) => {
          let words = e.querySelectorAll('.aboutWord')
          gsap.to(words, {
            yPercent: 0,
            stagger: 0.05,
            delay: i * 0.05
          })
        });
      }
    })
  })

  onDestroy(() => {
    if (scrollTriggerInstance) {
      scrollTriggerInstance.kill();
      scrollTriggerInstance = null;
    }
    if (splitElement) {
      splitElement.revert();
      splitElement = null;
    }
  })
}